'use client';
import React, { useState } from 'react';
import { Bell, Search, RefreshCw, Wifi, WifiOff } from 'lucide-react';

export default function Topbar() {
  const [liveConnected] = useState(true);
  const [alertCount] = useState(3);
  const [lastUpdated] = useState('13:56:02');

  return (
    <header className="h-14 bg-zinc-900 border-b border-zinc-800 flex items-center pl-14 lg:pl-6 pr-4 lg:pr-6 gap-3 lg:gap-4 flex-shrink-0">
      {/* Search — hidden on mobile */}
      <div className="hidden sm:flex flex-1 max-w-sm">
        <div className="relative w-full">
          <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-500" />
          <input
            type="text"
            placeholder="Search assets, jobs, drivers..."
            className="w-full bg-zinc-800 border border-zinc-700 rounded-md pl-8 pr-3 py-1.5 text-sm text-zinc-300 placeholder-zinc-600 focus:outline-none focus:border-amber-500/50 focus:ring-1 focus:ring-amber-500/20 transition-all"
          />
        </div>
      </div>

      <div className="flex items-center gap-2 lg:gap-3 ml-auto">
        {/* Live status */}
        <div className={`flex items-center gap-1.5 px-2 lg:px-2.5 py-1 rounded-full text-xs font-medium ${liveConnected ? 'bg-emerald-500/10 text-emerald-400 border border-emerald-500/20' : 'bg-red-500/10 text-red-400 border border-red-500/20'}`}>
          {liveConnected ? <Wifi size={11} /> : <WifiOff size={11} />}
          <span className="hidden sm:inline">{liveConnected ? 'Live' : 'Disconnected'}</span>
        </div>

        {/* Last updated — hidden on mobile */}
        <div className="hidden md:flex items-center gap-1 text-xs text-zinc-500 font-mono">
          <RefreshCw size={11} />
          <span>{lastUpdated}</span>
        </div>

        {/* Alerts */}
        <button className="relative p-2 rounded-md text-zinc-400 hover:bg-zinc-800 hover:text-zinc-200 transition-all duration-150">
          <Bell size={16} />
          {alertCount > 0 && (
            <span className="absolute top-1 right-1 w-3.5 h-3.5 bg-red-500 rounded-full text-[9px] font-bold text-white flex items-center justify-center">
              {alertCount}
            </span>
          )}
        </button>

        {/* Workspace badge — condensed on mobile */}
        <div className="flex items-center gap-2 pl-2 lg:pl-3 border-l border-zinc-800">
          <div className="text-right hidden sm:block">
            <p className="text-xs font-semibold text-zinc-300">Acme Drilling Co.</p>
            <p className="text-[10px] text-zinc-600">Standalone Mode</p>
          </div>
          <div className="w-7 h-7 rounded-full bg-amber-500/20 border border-amber-500/40 flex items-center justify-center flex-shrink-0 sm:hidden">
            <span className="text-[10px] font-bold text-amber-400">AC</span>
          </div>
        </div>
      </div>
    </header>
  );
}